import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackFbEvent } from '../utils/fbPixel';
export function Offer() {
  return <section id="offer" className="bg-forest py-24 md:py-32 px-6" data-id="element-136">
      <div className="max-w-2xl mx-auto text-center" data-id="element-137">
        <FadeIn data-id="element-138">
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-8" data-id="element-139">
            Reclaim your weekend.
          </h2>
          <p className="text-xl font-light mb-12 text-[#F5F0E8]" data-id="element-140">
            Get the full Sunday Reset Rescue Kit today.
          </p>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 mb-10" data-id="element-141">
            <div className="flex justify-center items-center gap-4 mb-8" data-id="element-142">
              <span className="text-3xl line-through decoration-red-400/50 text-[#070707]" data-id="element-143">
                $27
              </span>
              <span className="text-6xl font-serif text-gold" data-id="element-144">$6.39</span>
            </div>

            <motion.a href="https://yourresetkit.com/cart/47657190293644:1" onClick={() => {
            trackFbEvent('AddToCart', {
              content_name: 'Sunday Reset Rescue Kit',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gold text-white py-5 rounded-full text-xl font-medium tracking-wide shadow-lg hover:shadow-xl transition-all duration-300 mb-6 text-center" data-id="element-145">
              Get Instant Access
            </motion.a>

            <div className="flex items-center justify-center gap-2 text-cream text-sm" data-id="element-146">
              <ShieldCheck className="w-4 h-4" data-id="element-147" />
              <span data-id="element-148">Instant digital download. Secure checkout.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}